<template>
  <v-main :class="{ 'auth-background': !$vuetify.breakpoint.xs }">
    <v-container
      class="pa-0"
      :class="{ 'elevation-1': !$vuetify.breakpoint.xs }"
      style="max-width: 1000px"
    >
      <v-row>
        <v-col style="background: #ffb300" cols="12" sm="12" md="5" lg="5" xl="5" class="logo">
          <div class="pt-10">
            <logo-sologan></logo-sologan>
          </div>
        </v-col>

        <v-col style="background: #fff" cols="12" sm="12" md="7" lg="7" xl="7">
          <div class="mx-sm-4 px-sm-4 mx-md-10 px-md-10 py-lg-16 xs-screen">
            <v-form class="" ref="form" v-model="valid" lazy-validation>
              <div class="d-flex justify-center">
                <div class="text-h4 py-5 font-weight-bold" style="color: #ffb300">Đăng nhập.</div>
              </div>
              <v-text-field
                placeholder="Tài Khoản"
                name="login"
                prepend-inner-icon="person"
                v-model="credentials.identifier"
                :rules="[$rules.required, $rules.minLength(4)]"
                validate-on-blur
                @keyup.enter="submit"
                type="text"
                color="amber darken-1"
              />

              <v-text-field
                placeholder="Mật khẩu"
                v-model="credentials.password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                :rules="[$rules.required, $rules.minLength(4)]"
                validate-on-blur
                @keyup.enter="submit"
                prepend-inner-icon="lock"
                color="amber darken-1"
              />
            </v-form>
            <div class="d-flex justify-center py-3">
              <router-link
                :to="'/forgot-password'"
                class="font-italic text-decoration-none black--text"
                >Quên mật khẩu</router-link
              >
            </div>
            <v-divider class="amber darken-1" />
            <v-card-actions class="d-flex flex-column justify-content-center py-10">
              <v-btn color="#FFB300" class="px-12 white--text" x-large @click="submit"
                >Đăng Nhập</v-btn
              >
              <p class="pt-2">
                <!-- 
              Không có tài khoản?
              <router-link class="amber--text text-decoration-none" :to="'/signup'"
                >Đăng ký</router-link
              >
               -->
              </p>
            </v-card-actions>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <BaseDialog
      v-if="otpDialog.isOpen"
      :isOpen="otpDialog.isOpen"
      :title="otpDialog.title"
      @close="otpDialog.isOpen = false"
      @confirm="otpDialog.callback"
      @cancel="otpDialog.onCancel"
      @init="otpDialog.onInit"
      hideSecondaryBtn
      hidePrimaryBtn
    >
      <v-form
        class="flex-fill d-flex flex-column justify-center"
        lazy-validation
        ref="editMarkElementsDialog"
        v-model="otpDialog.valid"
      >
        <v-card-text class="mb-5 mb-sm-0">
          <!-- <p class="mb-2 font-weight-bold text-center text-h6">Nhập mã OTP</p> -->
          <VOtpInput
            @finish="onFinish($event)"
            length="6"
            v-model="otpDialog.otp"
            :disabled="loadingOtp"
          ></VOtpInput>
          <div class="w-100 d-flex justify-center py-2">
            <p class="m-0 text-center" v-if="sendOtpCountdown.value">
              Yêu cầu gửi lại mã sau {{ sendOtpCountdown.value }}s
            </p>
            <v-btn
              @click="onResendOtp()"
              class="ma-auto elevation-0"
              v-else
              color="primary"
              small
              :loading="loadingOtp"
            >
              Gửi lại mã OTP
            </v-btn>
          </div>
        </v-card-text>
      </v-form>
    </BaseDialog>
  </v-main>
</template>
<script>
import { Otp } from '@/plugins/api'
import { mapActions, mapState } from 'vuex'
import LogoSologan from '@/modules/image_logo/logo_sologan.vue'
import BaseDialog from '@/components/base/BaseDialog.vue'
import { VOtpInput } from 'vuetify/lib'

export default {
  components: {
    LogoSologan,
    BaseDialog,
    VOtpInput
  },
  data() {
    return {
      credentials: {
        identifier: '',
        password: ''
      },
      valid: false,
      loading: false,
      showPassword: false,
      password: 'Password',
      rules: {
        min: v => v.length >= 6 || 'Min 6 characters',
        emailMatch: () => "The email and password you entered don't match"
      },
      otpDialog: {
        isOpen: false,
        title: 'Nhập mã OTP',
        otp: '',
        onCancel: () => {
          this.otpDialog.isOpen = false
        },
        valid: false,
        callback: () => {}
      },
      sendOtpCountdown: {
        value: 0,
        counter: undefined
      },
      user: undefined
    }
  },
  methods: {
    ...mapActions('auth', ['signInWithOtp', 'resendOtp', 'signIn']),
    async onFinish(v) {
      console.log('finish')
      try {
        await this.otpDialogValidateCallback(v)
        await this.otpDialogSuccessCallback()
      } catch (error) {
        this.$alert.error(error || 'Có lỗi xảy ra')
      }
    },
    async onResendOtp() {
      if (!this.user) {
        return
      }
      try {
        await this.resendOtp(this.user)
        this.$alert.success('Mã OTP đã được gửi về hòm thư của bạn')
        this.refreshCountdown()
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra')
      }
    },
    refreshCountdown() {
      this.sendOtpCountdown.value = 90
      if (this.sendOtpCountdown.counter) {
        clearInterval(this.sendOtpCountdown.counter)
      }
      const handler = setInterval(() => {
        const newVal = Math.max(this.sendOtpCountdown.value - 1, 0)
        this.sendOtpCountdown.value = newVal
        if (!newVal) {
          if (this.sendOtpCountdown.counter) {
            clearInterval(this.sendOtpCountdown.counter)
            this.sendOtpCountdown.counter = undefined
          }
        }
      }, 1000)
      this.sendOtpCountdown.counter = handler
    },
    async submit() {
      const signinFormValid = this.$refs.form.validate()
      if (!signinFormValid) {
        this.$alert.error('Lỗi Form! Vui lòng kiểm tra lại')
        this.valid = signinFormValid
        return
      }
      try {
        this.loading = true
        if (process.env.NODE_ENV !== 'production') {
          await this.signIn(this.credentials)
        } else {
          const user = await this.signInWithOtp(this.credentials)
          this.user = (user || {}).id
          this.$nextTick(() => {
            this.otpDialog.onInit = (async () => {
              try {
                await this.otpDialogInitCallback()
                this.$alert.success('Mã OTP đã được gửi về hòm thư của bạn')
                this.refreshCountdown()
              } catch (error) {
                this.$alert.error('Có lỗi xảy ra! Không thể gửi mã OTP, vui lòng thử lại sau')
              }
            }).bind(this)
            this.otpDialog.callback = (async () => {
              const valid = this.$refs.otpDialog.validate()
              if (!valid) {
                this.$alert.error('Lỗi Form! Vui lòng kiểm tra lại')
                this.otpDialog.valid = valid
                return
              }
              try {
                await this.otpDialogValidateCallback(this.otpDialog.otp)
                await this.otpDialogSuccessCallback()
              } catch (error) {
                this.$alert.error(error.message)
              }
              this.otpDialog.isOpen = false
            }).bind(this)
            this.otpDialog.isOpen = true
          })
        }
      } catch (error) {
        this.$alert.error(error || 'Có lỗi xảy ra')
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapState('auth', [
      'showingOtpDialog',
      'otpDialogInitCallback',
      'otpDialogSuccessCallback',
      'otpDialogValidateCallback',
      'loadingOtp'
    ])
  }
}
</script>
<style scoped>
.auth-background {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url('../../assets/background.svg') no-repeat center center;
  background-size: cover;
  transform: scale(1);
  overflow: hidden;
}
.logo {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
@media screen and (max-width: 600px) {
  .xs-screen {
    padding: 20px;
  }
}
</style>
